import global from "global";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";

let sdk;

export default () => {
  if (!sdk) {
    const { adobeAnalyticsAccount } = clientConfigurationProvider();
    const appMeasurementInstance = global.s_gi(adobeAnalyticsAccount);

    sdk = {
      appMeasurementInstance,
      trackPage: appMeasurementInstance.t,
      trackLink: appMeasurementInstance.tl
    };
  }

  return sdk;
};
